import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Settings from "@/pages/Settings";
export const Route = createFileRoute("/settings")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><Settings /></ProtectedRoute>) });
